import * as util from "../util/index.js";
class Media {
    constructor() {
        this.id = util.getUuid();
        this.userId = "";
        this.userInfo = "";
        this.mediaId = "";
        this.deviceId = "";
        this.mediaType = "";
        this.appData = null;
        this.ref = "";
        this.mediaName = "";
        //  媒体状态 如果是本地媒体 0暂停生产 2已生产 如果是远程媒体 0暂停消费 2已消费 1为中间态
        this.state = 2;
    }
}
export default Media;
